export const UPLOAD_MAX_FILESIZE = 50 * 1000 * 1000 * 1024 // 50 gb = 50 * 1000 * 1000 * 1024 bytes
export const UPLOAD_MAX_FILESIZE_DISPLAY = '50 GB'
export const UPLOAD_CHUNK_SIZE = 990000
export const UPLOAD_STATUS = {
  UPLOADING: 'UPLOADING',
  CANCELLED: 'CANCELLED',
  NORMAL: 'NORMAL',
}
